import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { ConnectButton } from '@rainbow-me/rainbowkit'
import './Navbar.css'
import { getSavedLanguage, type Language } from './i18n'
import { NullayerLogoSimple } from './Logo'

interface NavbarProps {
  onNavigateHome?: () => void
  onLaunchApp?: () => void
  // Language
  currentLanguage?: Language
  onLanguageChange?: (lang: Language) => void
  // Show navigation links (when in app)
  showNavLinks?: boolean
}

export function Navbar({
  onNavigateHome,
  onLaunchApp,
  currentLanguage,
  onLanguageChange,
  showNavLinks = false
}: NavbarProps) {
  const [language, setLanguage] = useState<Language>(currentLanguage || getSavedLanguage())
  const location = useLocation()

  const content = {
    zh: {
      launchApp: '启动应用',
      connectWallet: '连接钱包',
      disconnect: '断开连接',
      wrongNetwork: '错误网络',
      mixer: '隐私盾',
      mining: '挖矿',
      leaderboard: '排行榜',
      dashboard: '我的'
    },
    en: {
      launchApp: 'Launch App',
      connectWallet: 'Connect Wallet',
      disconnect: 'Disconnect',
      wrongNetwork: 'Wrong Network',
      mixer: 'Shield',
      mining: 'Mining',
      leaderboard: 'Leaderboard',
      dashboard: 'My'
    }
  }

  const t = content[language]

  const handleLanguageToggle = () => {
    const newLang = language === 'zh' ? 'en' : 'zh'
    setLanguage(newLang)
    if (onLanguageChange) {
      onLanguageChange(newLang)
    }
  }

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-left">
          <button
            className="navbar-logo-button"
            onClick={onNavigateHome}
            style={{ cursor: onNavigateHome ? 'pointer' : 'default' }}
          >
            <NullayerLogoSimple size={28} className="navbar-logo-icon" />
            <span className="navbar-logo-text">NULLAYER</span>
          </button>
        </div>

        {/* Navigation Links - show when in app */}
        {showNavLinks && (
          <div className="navbar-center">
            <Link
              to="/shield"
              className={`navbar-nav-link ${location.pathname === '/shield' ? 'active' : ''}`}
            >
              {t.mixer}
            </Link>
            <Link
              to="/mining"
              className={`navbar-nav-link ${location.pathname === '/mining' ? 'active' : ''}`}
            >
              {t.mining}
            </Link>
            <Link
              to="/leaderboard"
              className={`navbar-nav-link ${location.pathname === '/leaderboard' ? 'active' : ''}`}
            >
              {t.leaderboard}
            </Link>
            <Link
              to="/dashboard"
              className={`navbar-nav-link ${location.pathname === '/dashboard' ? 'active' : ''}`}
            >
              {t.dashboard}
            </Link>
          </div>
        )}

        <div className="navbar-right">
          {/* Launch App button - only show on landing page */}
          {onLaunchApp && (
            <button className="navbar-launch-button" onClick={onLaunchApp}>
              <span className="navbar-launch-text">{t.launchApp}</span>
              <span className="navbar-launch-arrow">→</span>
            </button>
          )}

          {/* App controls - show when in app */}
          {!onLaunchApp && (
            <>
              {/* Language Toggle */}
              <button
                className="navbar-icon-button"
                onClick={handleLanguageToggle}
                title={language === 'zh' ? 'Switch to English' : '切换到中文'}
              >
                {language === 'zh' ? '🇨🇳' : '🇺🇸'}
              </button>

              {/* RainbowKit Connect Button */}
              <ConnectButton showBalance={false} chainStatus="icon" />
            </>
          )}
        </div>
      </div>
    </nav>
  )
}
